import React, { useState, useEffect } from 'react';
export default function Blink({ blinkImg, regImg, style={}}) {
    const [showBlink, setShowBlink] = useState(false); // default is eyes open
    useEffect(() => {
        const interval = setInterval(() => {
            setShowBlink(show => !show)
        }, 500)
            return () => clearInterval(interval)
        }, [])

    const baseStyle = {
        width: '30%',
        borderRadius: 0,
        display: 'block',
        gridColumn: 1,
    }

    const finalStyle = {...baseStyle, ...style}
    
    return (
        <div>
            <img src={showBlink ? blinkImg : regImg} alt="" style={finalStyle} />
        </div>
    )
}
